export default __webpack_public_path__ + "d2711bda5240a1c01acd894d5abb3b76.svg";